<template>
  <v-container fill-height fluid grid-list-xl>
    <v-layout justify-center wrap class="chartBox">
      <v-flex md5>
        <material-card title="Drug SAR" color="success">

          <v-layout justify-center wrap>
            <v-flex md6>
              <v-autocomplete
                clearable
                v-model="item.drug"
                :items="drugs"
                placeholder="Choose drug"
                item-text="name"
                item-value="id"
              />
            </v-flex>
            <v-flex md6>
              <safety-daterange
                displayFormat="yyyy-MM-dd"
                clearable
                v-model="item.receipt_date"
                placeholder="Choose date range"
              />
            </v-flex>
            <v-flex md12>
              <v-select
              :disabled="!item.drug"
                multiple
                clearable
                chips
                dense
                deletable-chips
                v-model="item.protocols"
                :items="protocolList"
                placeholder="Choose Protocols"
                item-text="name"
                item-value="id"
              />
            </v-flex>
          </v-layout>

          <v-btn
            :disabled="!(item.protocols.length && item.drug)"
            dense
            color="success"
            class="white--text"
            :loading="loading['sar_drug']"
            @click="report('sar_drug')"
          >
            <v-icon>mdi-file-excel</v-icon>
            Download .xls
          </v-btn>
        </material-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>


<script>
import { getList, remove, get, downloadExcel } from "@/api/base_api";
import { report } from "@/api/report";

export default {
  data() {
    return {
      item: {protocols:[], drug:null, receipt_date:{}},
      loading: {sar_drug:false},
      drugs: [],
      protocolList:[],
      drugsList:[]
    };
  },
  computed: {
    sponsorId() {
      return this.$store.getters.sponsor_id;
    },
    // allProtocols() {
    //   return this.$store.getters.protocols;
    // },
    now() {
      const d = new Date();
      return (
        d.toLocaleString("en-us", {
          day: "numeric",
          month: "long",
          year: "numeric",
        }) +
        " " +
        d.toLocaleTimeString()
      );
    },
  },
  created() {
    this.$store.dispatch("app/loadSponsors");
    this.$store.dispatch("app/sponsorsDisabled", false);
    this.$root.$on('sponsorChanged', (v) => {
      this.item.protocols = []
    })
  },
   destroyed() {
    this.$root.$off('sponsorChanged');
  },
  watch: {
    'item.drug'(newVal, oldVal) {
    if (newVal) {
      this.item.protocols=[]
      newVal=this.capitalizeFirst(newVal)
      this.protocolList=this.drugsList.filter(drug=>drug.drug===newVal && drug.protocol.sponsor_id===this.$store.getters.sponsor_id).map((drug) => { return {id:drug.protocol.id,name:drug.protocol.name}})
      
    }else{
      this.protocolList=[];
      this.item.protocols=[]
    }
  },
  sponsorId(newVal, oldVal) {
    if (newVal !== oldVal) {
      this.item.drug = null;
      this.item.protocols=[]
      this.protocolList = [];
    }
  },
  },
  mounted() {
    getList("treatment", null, { rowsPerPage: -1 }).then((ret) => {
      this.drugsList=ret.data
      this.drugs = ret.data
        .map((dr) => {
          return dr.drug.toUpperCase();
        })
        .filter((value, index, array) => {
          return array.indexOf(value) === index;
        }).filter(item => typeof item === 'string')
          .map(item => item.trim())
          .sort((a, b) => a.localeCompare(b));
      });    
  },
  methods: {
    report(type) {
      this.loading[type] = true
      report(type, this.item).then( ret => {

      }).finally( () => {
        this.loading[type] = false
      })
      
    },
      capitalizeFirst(str) {
      if (!str) return '';
      str = str.toLowerCase();
      return str.charAt(0).toUpperCase() + str.slice(1);
    }
  },
};
</script>

<style lang="scss">
#company_dataTable {
  .v-datatable__actions {
    color: black;
    .v-btn__content {
      color: black;
    }
    .v-btn {
      background-color: rgb(241, 241, 241);
    }
  }

  tr.lighten-3 th {
    padding: 0px 5px 0px 5px;
  }
}
</style>